/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/no-unstable-nested-components */
import {
  Heading,
  FormControl,
  FormLabel,
  Input,
  Checkbox,
} from "@chakra-ui/react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import moment from "moment";
import { dateFormat } from "../../utils/constants";

export function ServicePointDetails({ servicePoint }) {
  return (
    <form>
      <FormControl>
        <FormLabel>Customer</FormLabel>
        <Input readOnly value={servicePoint.customer} />
      </FormControl>
      <FormControl>
        <FormLabel>Billing Customer</FormLabel>
        <Input readOnly value={servicePoint.billingCustomerName} />
      </FormControl>
      <FormControl>
        <FormLabel>Contract Code</FormLabel>
        <Input readOnly value={servicePoint.contractCode} />
      </FormControl>
      <FormControl>
        <FormLabel>Cash Center</FormLabel>
        <Input readOnly value={servicePoint.cashCenter} />
      </FormControl>
      <FormControl>
        <FormLabel>Location ID</FormLabel>
        <Input readOnly value={servicePoint.locationId} />
      </FormControl>
      <FormControl>
        <FormLabel>Location Name</FormLabel>
        <Input readOnly value={servicePoint.locationName} />
      </FormControl>
      <FormControl>
        <FormLabel>Location Code</FormLabel>
        <Input readOnly value={servicePoint.locationCode} />
      </FormControl>
      <FormControl>
        <FormLabel>Category</FormLabel>
        <Input readOnly value={servicePoint.category} />
      </FormControl>
      <FormControl>
        <FormLabel>Route</FormLabel>
        <Input readOnly value={servicePoint.routeNo} />
      </FormControl>
      <FormControl>
        <FormLabel>Location Type</FormLabel>
        <Input readOnly value={servicePoint.locationType} />
      </FormControl>
      <FormControl>
        <FormLabel>Status</FormLabel>
        <Input readOnly value={servicePoint.status} />
      </FormControl>
      <FormControl>
        <FormLabel>Site Type</FormLabel>
        <Input readOnly value={servicePoint.siteType} />
      </FormControl>
      <FormControl>
        <FormLabel>Barcode</FormLabel>
        <Input readOnly value={servicePoint.barcode} />
      </FormControl>
      <FormControl>
        <FormLabel>Site Limit</FormLabel>
        <Input readOnly value={servicePoint.siteLimit} />
      </FormControl>
      <FormControl>
        <FormLabel>Distance From Base</FormLabel>
        <Input readOnly value={servicePoint.distanceFromBase} />
      </FormControl>
      <FormControl>
        <FormLabel>Co-Located Group No</FormLabel>
        <Input readOnly value={servicePoint.coLocatedGroupNo || ""} />
      </FormControl>
      <FormControl>
        <FormLabel>Country</FormLabel>
        <Input readOnly value={servicePoint.country} />
      </FormControl>
      <FormControl>
        <FormLabel>State</FormLabel>
        <Input readOnly value={servicePoint.state} />
      </FormControl>
      <FormControl>
        <FormLabel>City</FormLabel>
        <Input readOnly value={servicePoint.city} />
      </FormControl>
      <FormControl>
        <FormLabel>Emirate</FormLabel>
        <Input readOnly value={servicePoint.emirate} />
      </FormControl>
      <FormControl>
        <FormLabel>Address</FormLabel>
        <Input readOnly value={servicePoint.address} />
      </FormControl>
      <FormControl>
        <FormLabel>Longitude</FormLabel>
        <Input readOnly value={servicePoint.longitude} />
      </FormControl>
      <FormControl>
        <FormLabel>Latitude</FormLabel>
        <Input readOnly value={servicePoint.latitude} />
      </FormControl>
      <FormControl>
        <FormLabel>First Service Date</FormLabel>
        <Input
          readOnly
          value={
            servicePoint.firstServiceDate &&
            moment(servicePoint.firstServiceDate).isValid()
              ? moment(servicePoint.firstServiceDate).format(dateFormat)
              : ""
          }
        />
      </FormControl>
      <FormControl>
        <FormLabel>Service Days</FormLabel>
        <Input readOnly value={servicePoint.serviceDays?.join(",") || ""} />
      </FormControl>
      <FormControl>
        <FormLabel>Allowed Days</FormLabel>
        <Input readOnly value={servicePoint.allowedDays?.join(",") || ""} />
      </FormControl>
      <FormControl>
        <FormLabel>Alarm Details</FormLabel>
        <Input readOnly value={servicePoint.alarmDetails} />
      </FormControl>
      <FormControl>
        <FormLabel>Fixing Side</FormLabel>
        <Input readOnly value={servicePoint.fixingSide} />
      </FormControl>
      <FormControl>
        <FormLabel>Loading Side</FormLabel>
        <Input readOnly value={servicePoint.loadingSide} />
      </FormControl>
      <FormControl>
        <FormLabel>Machine Type</FormLabel>
        <Input readOnly value={servicePoint.machineType} />
      </FormControl>
      <FormControl>
        <FormLabel>Maker</FormLabel>
        <Input readOnly value={servicePoint.maker} />
      </FormControl>
      <FormControl>
        <FormLabel>Model</FormLabel>
        <Input readOnly value={servicePoint.model} />
      </FormControl>
      <FormControl>
        <FormLabel>Lock Serial No</FormLabel>
        <Input readOnly value={servicePoint.lockSerialNo} />
      </FormControl>
      <FormControl>
        <FormLabel>Machine Serial No</FormLabel>
        <Input readOnly value={servicePoint.machineSerialNo} />
      </FormControl>
      <FormControl>
        <FormLabel>Maximum Cassettes</FormLabel>
        <Input readOnly value={servicePoint.maximumCassettes} />
      </FormControl>
      <FormControl>
        <FormLabel>Lock Installation Date</FormLabel>
        <Input
          readOnly
          value={
            servicePoint.lockInstallationDate &&
            moment(servicePoint.lockInstallationDate).isValid()
              ? moment(servicePoint.lockInstallationDate).format(dateFormat)
              : ""
          }
        />
      </FormControl>
      <FormControl>
        <FormLabel>Number of Cassettes</FormLabel>
        <Input readOnly value={servicePoint.numberOfCassettes} />
      </FormControl>
      <FormControl>
        <FormLabel>Keys</FormLabel>
        <Input readOnly value={servicePoint.numberOfKeys} />
      </FormControl>
      <FormControl>
        <FormLabel>Bins</FormLabel>
        <Input readOnly value={servicePoint.numberOfBins} />
      </FormControl>
      <FormControl>
        <FormLabel>Has Camera</FormLabel>
        <Input readOnly value={servicePoint.hasCamera ? "Yes" : "No"} />
      </FormControl>
      <FormControl>
        <FormLabel>Camera Type</FormLabel>
        <Input readOnly value={servicePoint.cameraType} />
      </FormControl>
      <FormControl>
        <FormLabel>Area</FormLabel>
        <Input readOnly value={servicePoint.area} />
      </FormControl>
      <FormControl>
        <FormLabel>Machine Installation Date</FormLabel>
        <Input
          readOnly
          value={
            servicePoint.machineInstallationDate &&
            moment(servicePoint.machineInstallationDate).isValid()
              ? moment(servicePoint.machineInstallationDate).format(dateFormat)
              : ""
          }
        />
      </FormControl>

      {/* Boolean Fields */}
      <FormControl style={{ display: "flex", flexDirection: "row" }}>
        <Checkbox isChecked={servicePoint.requiresCashierCount}>
          <FormLabel style={{ margin: 0 }}>Requires Cashier Count</FormLabel>
        </Checkbox>
      </FormControl>
      <FormControl style={{ display: "flex", flexDirection: "row" }}>
        <Checkbox isChecked={servicePoint.requiresEVhr}>
          <FormLabel style={{ margin: 0 }}>Requires EVhr</FormLabel>
        </Checkbox>
      </FormControl>
      <FormControl style={{ display: "flex", flexDirection: "row" }}>
        <Checkbox isChecked={servicePoint.hasSecurityAlarm}>
          <FormLabel style={{ margin: 0 }}>Has Security Alarm</FormLabel>
        </Checkbox>
      </FormControl>
      <FormControl style={{ display: "flex", flexDirection: "row" }}>
        <Checkbox isChecked={servicePoint.followsCustomerSla}>
          <FormLabel style={{ margin: 0 }}>Follows Customer SLA</FormLabel>
        </Checkbox>
      </FormControl>
      <FormControl style={{ display: "flex", flexDirection: "row" }}>
        <Checkbox isChecked={servicePoint.followsCustomerServiceWindow}>
          <FormLabel style={{ margin: 0 }}>
            Follows Customer Access Timing
          </FormLabel>
        </Checkbox>
      </FormControl>
      {servicePoint.locationId ? (
        <>
          <Heading
            style={{ fontSize: "16px", margin: "25px 0", width: "100%" }}
          >
            Multiple Onward Location
          </Heading>
          <MultipleOnwardLocation locations={servicePoint.onwardLocations} />
          {/* Site SLAs */}
          <Heading
            style={{ fontSize: "16px", margin: "25px 0", width: "100%" }}
          >
            Site SLAs
          </Heading>
          <SiteSLAs SLAList={servicePoint.siteSLAs} />

          {/* Operational Windows */}
          {/* <Heading
            style={{ fontSize: "16px", margin: "25px 0", width: "100%" }}
          >
            Operational Windows
          </Heading>
          <OperationalWindow
            operationalWindows={servicePoint.operationalWindows}
          /> */}

          {/* Service Windows */}
          <Heading
            style={{ fontSize: "16px", margin: "25px 0", width: "100%" }}
          >
            Access Time
          </Heading>
          <ServiceWindowsGrid serviceWindows={servicePoint.serviceWindows} />

          {/* Cassettes */}
          {/* <Heading
            style={{ fontSize: "16px", margin: "25px 0", width: "100%" }}
          >
            Cassettes
          </Heading>
          <Cassettes cassettes={servicePoint.cassettes} /> */}

          {/* Denominations */}
          <Heading
            style={{ fontSize: "16px", margin: "25px 0", width: "100%" }}
          >
            Denominations
          </Heading>
          <Denominations denominations={servicePoint.denominations} />

          {/* Replenishment Models */}
          {/* <Heading
            style={{ fontSize: "16px", margin: "25px 0", width: "100%" }}
          >
            Replenishment Models
          </Heading>
          <ReplenishmentModels
            replenishmentModels={servicePoint.replenishmentModels}
          /> */}

          {/* Site Representatives */}
          <Heading
            style={{ fontSize: "16px", margin: "25px 0", width: "100%" }}
          >
            Site Representatives
          </Heading>
          <Representatives representatives={servicePoint.siteRepresentatives} />
          <Heading
            style={{ fontSize: "16px", margin: "25px 0", width: "100%" }}
          >
            Scheduled Services
          </Heading>
          <ServiceSchedules data={servicePoint.serviceSchedules} />
        </>
      ) : null}
    </form>
  );
}

function ContainerCell({ dataItem }) {
  return (
    <td>
      {dataItem?.allowedContainerTypes?.map((i) => i.description)?.join(", ")}
    </td>
  );
}

function MultipleOnwardLocation({ locations }) {
  return (
    <Grid data={locations}>
      <GridColumn title="Cash Center" field="cashCenter" />
      <GridColumn title="Customer" field="customer" />
      <GridColumn title="Location" field="locationName" />
      <GridColumn title="Type" field="locationType" />
      <GridColumn title="Barcode" field="barcode" />
      <GridColumn
        title="Bag Type"
        field="allowedContainerTypes"
        cell={ContainerCell}
      />
    </Grid>
  );
}

/* -------------------------- CHILD COMPONENTS -------------------------- */

function SiteSLAs({ SLAList }) {
  return (
    <Grid data={SLAList || []}>
      <GridColumn title="Activity Type" field="activityType" />
      <GridColumn title="Response Time(mins)" field="responseTime" />
      <GridColumn title="Attended Time(mins)" field="attendedTime" />
      <GridColumn title="Resolution Time(mins)" field="resolutionTime" />
    </Grid>
  );
}

function ServiceWindowsGrid({ serviceWindows }) {
  return (
    <Grid data={serviceWindows || []}>
      <GridColumn
        title="Day"
        cell={({ dataItem }) => <td>{dataItem.dayOfWeek || "-"}</td>}
      />
      <GridColumn
        title="Start Time"
        cell={({ dataItem }) => <td>{dataItem?.startTime || ""}</td>}
      />
      <GridColumn
        title="End Time"
        cell={({ dataItem }) => <td>{dataItem?.endTime || ""}</td>}
      />
      <GridColumn
        title="Second Start Time"
        cell={({ dataItem }) => <td>{dataItem?.secondStartTime || "-"}</td>}
      />
      <GridColumn
        title="Second End"
        cell={({ dataItem }) => <td>{dataItem?.secondEndTime || "-"}</td>}
      />
    </Grid>
  );
}

function Denominations({ denominations }) {
  return (
    <Grid data={denominations || []}>
      <GridColumn title="Currency" field="currency" />
      <GridColumn title="Multiple" field="multiple" />
      <GridColumn title="Shape" field="shape" />
      <GridColumn title="Version" field="version" />
    </Grid>
  );
}

function Representatives({ representatives }) {
  return (
    <Grid data={representatives || []}>
      <GridColumn title="Name" field="name" />
      <GridColumn title="Employee ID" field="employeeId" />
      <GridColumn title="Email" field="email" />
      <GridColumn title="Mobile No" field="mobileNo" />
    </Grid>
  );
}

function ServiceSchedules({ data }) {
  return (
    <Grid data={data} style={{ width: "100%" }}>
      <GridColumn title="Scheduled Type" field="scheduleType" />
      <GridColumn title="Service Type" field="serviceType" />
      <GridColumn title="Job Type" field="jobType" />
      <GridColumn title="Route No" field="routeNo" />
      <GridColumn
        title="Week Days"
        cell={({ dataItem }) => <td>{dataItem.weekDays?.join(", ")}</td>}
      />{" "}
      <GridColumn
        title="Month Date"
        field="jobType"
        cell={({ dataItem }) => <td>{dataItem.monthDates?.join(", ")}</td>}
      />
    </Grid>
  );
}
